export const elevatorNumber = {
  className: 'cls-16',
  d: 'm364.5898,112.0674h-6.4482l-.6504,4.3418c.3896-.0518.7539-.1035,1.3779-.1035,1.2998,0,2.6006.2861,3.6406.9102,1.3262.7539,2.418,2.21,2.418,4.3418,0,3.3027-2.626,5.7725-6.293,5.7725-1.8457,0-3.4053-.5205-4.2119-1.04l.5723-1.7422c.7021.416,2.0801.9355,3.6143.9355,2.1582,0,4.0039-1.4033,4.0039-3.666-.0254-2.1836-1.4824-3.7441-4.8623-3.7441-.9619,0-1.7158.1045-2.3398.1826l1.0918-8.1123h8.0869v1.9238Z',
}

export const FLOOR_5_DATA = [
  {
    id: 'A015',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'A015',
    sceneName: 'scene_05krs_A015',
    sceneName_future: 'scene_05krs_A015_future',
    name: 'A015',
    label: 'A15',
    lookAt: '-209.68, 0, 120',
    face: 'south',
    area: {
      className: 'cls-30',
      points:
        '141.0833 43.4356 141.0833 73.9349 109.4583 73.9369 109.4583 65.3958 110.9444 65.3964 108 43.4356 141.0833 43.4356',
    },
    viewCone: {
      className: 'cls-3',
      pathData:
        'm129.8458,74.1422c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '127.1682',
      cy: '69.6956',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm123.0479,57.6846h-1.5469l-.4473-1.4023h-2.2422l-.4434,1.4023h-1.5381l2.2939-6.3018h1.6836l2.2402,6.3018Zm-2.3203-2.4922l-.6758-2.1172c-.0508-.1582-.0859-.3477-.1055-.5674h-.0352c-.0156.1846-.0518.3682-.1104.5498l-.6855,2.1348h1.6123Z',
      },
      {
        className: 'cls-8',
        d: 'm127.8467,57.6846h-3.9854v-1.0986h1.3057v-3.9248l-1.3408.291v-1.125l2.7246-.5498v5.3086h1.2959v1.0986Z',
      },
      {
        className: 'cls-8',
        d: 'm129.0117,57.5225v-1.1875c.4307.2637.8887.3965,1.375.3965.3662,0,.6533-.0879.8594-.2617.207-.1748.3105-.4111.3105-.71,0-.624-.4414-.9365-1.3232-.9365-.2871,0-.6348.0273-1.042.0801v-3.5205h3.4902v1.1338h-2.3027v1.2617c.1836-.0176.3584-.0273.5225-.0273.6475,0,1.1543.1709,1.5205.5098.3662.3408.5488.7979.5488,1.3711,0,.6367-.2178,1.1553-.6543,1.5586-.4365.4023-1.0283.6035-1.7754.6035-.6064,0-1.1162-.0908-1.5293-.2715Z',
      },
    ],

    relatedApartments: {
      2: 'A001',
      3: 'A005',
      4: 'A011',
      6: 'B024-2',
      7: 'C050',
      8: 'C054-2',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'A016',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'A016',
    sceneName: 'scene_05krs_A016',
    sceneName_future: 'scene_05krs_A016_future',
    name: 'A016',
    label: 'A16',
    lookAt: '-133.71, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-30',
      points:
        '90.8297 17.5419 42.4489 30.3812 55.7417 79.5738 77.0946 73.9373 109.4583 65.3958 110.75 65.3958 108 43.4356 91.4167 47.2917 87.5833 33.25 94.3889 31.3889 90.8297 17.5419',
    },
    viewCone: {
      className: 'cls-18',
      pathData:
        'm64.7431,53.8058c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '62.0655',
      cy: '49.3592',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-25',
        d: 'm91.3184,59.8066h-1.5469l-.4482-1.4023h-2.2412l-.4434,1.4023h-1.5381l2.2939-6.3018h1.6826l2.2412,6.3018Zm-2.3203-2.4922l-.6768-2.1172c-.0498-.1582-.085-.3477-.1055-.5674h-.0352c-.0146.1846-.0508.3682-.1094.5498l-.6855,2.1348h1.6123Z',
      },
      {
        className: 'cls-25',
        d: 'm96.1172,59.8066h-3.9854v-1.0986h1.3047v-3.9248l-1.3398.291v-1.125l2.7246-.5498v5.3086h1.2959v1.0986Z',
      },
      {
        className: 'cls-25',
        d: 'm100.9912,53.5703v1.1602c-.3193-.1807-.668-.2715-1.0459-.2715-.4658,0-.8418.1777-1.127.5332-.2861.3564-.4346.833-.4463,1.4307h.0264c.3018-.4453.7422-.668,1.3223-.668.5273,0,.9453.1787,1.2549.5361.3086.3574.4639.8301.4639,1.4199,0,.6328-.2051,1.1582-.6152,1.5771s-.9316.6279-1.5645.6279c-.709,0-1.2627-.2559-1.6611-.7686s-.5977-1.2314-.5977-2.1572c0-1.0898.2559-1.9609.7686-2.6133.5127-.6514,1.209-.9775,2.0879-.9775.4863,0,.8643.0576,1.1338.1709Zm-1.7402,3.2129c-.2549,0-.458.0898-.6084.2676-.1514.1797-.2266.4082-.2266.6855,0,.3086.0771.5713.2305.7891.1543.2188.3584.3281.6133.3281.249,0,.4482-.0977.5977-.293.1494-.1943.2236-.4482.2236-.7617,0-.6777-.2764-1.0156-.8301-1.0156Z',
      },
    ],

    relatedApartments: {
      2: 'A001',
      3: 'A007',
      4: 'A012-1',
      6: 'B024-1',
      7: 'B026',
      8: 'C054-1',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'B021',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'B021',
    sceneName: 'scene_05krs_B021',
    sceneName_future: 'scene_05krs_B021_future',
    name: 'B021',
    label: 'B21',
    lookAt: '-209.68, 0, 120',
    face: 'south',
    area: {
      className: 'cls-30',
      points: '',
      x: '141.0833',
      y: '43.4356',
      width: '33.5',
      height: '30.5006',
    },
    viewCone: {
      className: 'cls-24',
      pathData:
        'm160.0958,74.3845c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '157.4182',
      cy: '69.938',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm150.4922,57.6846v-6.3018h2.2939c.7031,0,1.2432.1289,1.6221.3867.377.2578.5664.6211.5664,1.0898,0,.3398-.1152.6377-.3447.8916-.2305.2559-.5244.4326-.8818.5322v.0176c.4492.0557.8066.2217,1.0752.4971.2676.2754.4014.6104.4014,1.0059,0,.5771-.2061,1.0352-.6191,1.373-.4131.3389-.9775.5078-1.6914.5078h-2.4219Zm1.4199-5.2559v1.4941h.623c.293,0,.5244-.0713.6924-.2129.1689-.1426.2529-.3379.2529-.5869,0-.4629-.3457-.6943-1.0371-.6943h-.5312Zm0,2.5488v1.6611h.7686c.3281,0,.585-.0762.7715-.2285.1855-.1523.2783-.3604.2783-.624,0-.252-.0908-.4492-.2744-.5938-.1826-.1426-.4385-.2148-.7666-.2148h-.7773Z',
      },
      {
        className: 'cls-8',
        d: 'm157.6123,56.5068v.0264h2.5566v1.1514h-4.1484v-1.0811l1.8066-1.7275c.3633-.3477.6191-.6406.7666-.876.1484-.2363.2217-.4844.2217-.7451,0-.5801-.3115-.8701-.9355-.8701-.542,0-1.0605.2158-1.5557.6455v-1.2207c.5479-.3545,1.166-.5322,1.8545-.5322.6445,0,1.1475.1621,1.5098.4854.3613.3242.543.7617.543,1.3125,0,.7354-.4414,1.4951-1.3232,2.2803l-1.2959,1.1514Z',
      },
      {
        className: 'cls-8',
        d: 'm165.4502,57.6846h-3.9854v-1.0986h1.3057v-3.9248l-1.3408.291v-1.125l2.7246-.5498v5.3086h1.2959v1.0986Z',
      },
    ],

    relatedApartments: {
      2: 'A001',
      3: 'B017',
      4: 'B019',
      6: 'B023',
      7: 'C050',
      8: 'C054-2',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'B022',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'B022',
    sceneName: 'scene_05krs_B022',
    sceneName_future: 'scene_05krs_B022_future',
    name: 'B022',
    label: 'B22',
    lookAt: '-389.51, 0, 120',
    face: 'north',
    area: {
      className: 'cls-30',
      points:
        '163.2778 14.4295 163.2778 28.6667 155.8889 28.6623 155.8889 43.4356 127.9167 43.4353 127.9167 36.6676 127.9167 14.4353 163.2778 14.4295',
    },
    viewCone: {
      className: 'cls-14',
      pathData:
        'm136.5333,22.0056c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '133.8557',
      cy: '17.559',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm134.7422,35.6113v-6.3018h2.2939c.7031,0,1.2432.1289,1.6221.3867.377.2578.5664.6211.5664,1.0898,0,.3398-.1152.6377-.3447.8916-.2305.2559-.5244.4326-.8818.5322v.0176c.4492.0557.8066.2217,1.0752.4971.2676.2754.4014.6104.4014,1.0059,0,.5771-.2061,1.0352-.6191,1.373-.4131.3389-.9775.5078-1.6914.5078h-2.4219Zm1.4199-5.2559v1.4941h.623c.293,0,.5244-.0713.6924-.2129.1689-.1426.2529-.3379.2529-.5869,0-.4629-.3457-.6943-1.0371-.6943h-.5312Zm0,2.5488v1.6611h.7686c.3281,0,.585-.0762.7715-.2285.1855-.1523.2783-.3604.2783-.624,0-.252-.0908-.4492-.2744-.5938-.1826-.1426-.4385-.2148-.7666-.2148h-.7773Z',
      },
      {
        className: 'cls-8',
        d: 'm141.8613,34.4336v.0264h2.5566v1.1514h-4.1484v-1.0811l1.8066-1.7275c.3633-.3477.6191-.6406.7666-.876.1484-.2363.2217-.4844.2217-.7451,0-.5801-.3115-.8701-.9355-.8701-.542,0-1.0605.2158-1.5557.6455v-1.2207c.5479-.3545,1.166-.5322,1.8545-.5322.6445,0,1.1475.1621,1.5098.4854.3613.3242.543.7617.543,1.3125,0,.7354-.4414,1.4951-1.3232,2.2803l-1.2959,1.1514Z',
      },
      {
        className: 'cls-8',
        d: 'm147.0391,34.4336v.0264h2.5566v1.1514h-4.1484v-1.0811l1.8066-1.7275c.3633-.3477.6191-.6406.7666-.876.1484-.2363.2217-.4844.2217-.7451,0-.5801-.3115-.8701-.9355-.8701-.542,0-1.0605.2158-1.5557.6455v-1.2207c.5479-.3545,1.166-.5322,1.8545-.5322.6445,0,1.1475.1621,1.5098.4854.3613.3242.543.7617.543,1.3125,0,.7354-.4414,1.4951-1.3232,2.2803l-1.2959,1.1514Z',
      },
    ],

    relatedApartments: {
      2: 'A002',
      3: 'B018',
      4: 'B020',
      6: 'B025',
      7: 'B026',
      8: 'C054-1',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'C038',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'C038',
    sceneName: 'scene_05krs_C038',
    sceneName_future: 'scene_05krs_C038_future',
    name: 'C038',
    label: 'C38',
    lookAt: '55.21, 0, 120',
    face: 'east',
    area: {
      className: 'cls-30',
      points:
        '272.7292 14.4226 277.3632 65.2781 240 65.4167 240 14.4254 272.7292 14.4226',
    },
    viewCone: {
      className: 'cls-21',
      pathData:
        'm274.1223,32.7301c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '271.4447',
      cy: '28.2835',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm253.1934,47.5303c-.46.2236-1.0605.334-1.8018.334-.9668,0-1.7275-.2832-2.2803-.8516-.5547-.5684-.8311-1.3262-.8311-2.2725,0-1.0078.3115-1.8252.9336-2.4521.623-.627,1.4307-.9404,2.4238-.9404.6152,0,1.1338.0781,1.5557.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0693.1865-1.4326.5586s-.5449.876-.5449,1.5117c0,.6094.1709,1.0947.5146,1.4561.3418.3623.8037.543,1.3838.543.5537,0,1.0605-.1348,1.5205-.4043v1.2959Z',
      },
      {
        className: 'cls-8',
        d: 'm254.2178,47.5479v-1.208c.4219.3076.9141.4619,1.4766.4619.3535,0,.6299-.0762.8281-.2285.1973-.1523.2969-.3652.2969-.6377,0-.2812-.123-.498-.3672-.6504-.2451-.1523-.5811-.2285-1.0088-.2285h-.5674v-1.0635h.5234c.8203,0,1.2305-.2725,1.2305-.8174,0-.5127-.3154-.7686-.9453-.7686-.4219,0-.832.1357-1.2305.4082v-1.1338c.4424-.2227.959-.334,1.5469-.334.6445,0,1.1465.1455,1.5059.4346.3584.291.5381.667.5381,1.1299,0,.8232-.417,1.3389-1.2529,1.5469v.0225c.4453.0557.7969.2168,1.0547.4854.2578.2676.3867.5967.3867.9863,0,.5889-.2148,1.0547-.6455,1.3975s-1.0254.5137-1.7842.5137c-.6504,0-1.1797-.1055-1.5859-.3164Z',
      },
      {
        className: 'cls-8',
        d: 'm260.3789,44.4814v-.0225c-.7207-.2959-1.082-.7744-1.082-1.4365,0-.4863.1934-.8877.5801-1.2021.3867-.3154.8867-.4727,1.499-.4727.624,0,1.1221.1475,1.4941.4414.3721.2949.5576.6748.5576,1.1406,0,.6885-.3984,1.1953-1.1953,1.5205v.0176c.4277.126.7598.333.9961.6221.2354.2881.3535.6123.3535.9736,0,.5566-.2061.9961-.6172,1.3184-.4121.3223-.9863.4824-1.7246.4824-.6396,0-1.1543-.1572-1.5449-.4717-.3916-.3154-.5869-.7314-.5869-1.251,0-.752.4229-1.3057,1.2705-1.6602Zm.9268.5273c-.5889.2314-.8838.5859-.8838,1.0625,0,.2285.0908.418.2705.5674.1807.1494.3994.2236.6572.2236.2783,0,.502-.0723.6719-.2188s.2559-.3398.2559-.5801c0-.4805-.3242-.832-.9717-1.0547Zm.8174-1.9609c0-.2129-.0684-.3838-.2041-.5117-.1367-.127-.3174-.1914-.543-.1914-.2197,0-.4023.0674-.5469.2002-.1455.1338-.2178.3047-.2178.5127,0,.3926.252.6895.7559.8916.5039-.208.7559-.5078.7559-.9014Z',
      },
    ],

    relatedApartments: {
      2: 'C027',
      3: 'C028',
      4: 'C033',
      6: 'C043',
      7: 'C048',
      8: 'C053',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'C039',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'C039',
    sceneName: 'scene_05krs_C039',
    sceneName_future: 'scene_05krs_C039_future',
    name: 'C039',
    label: 'C39',
    lookAt: '-209.68, 0, 120',
    face: 'south',
    area: {
      className: 'cls-30',
      points:
        '240 43.4353 240 65.4167 240.7722 73.9349 207.5417 73.9346 207.5417 43.4353 240 43.4353',
    },
    viewCone: {
      className: 'cls-15',
      pathData:
        'm227.0333,74.2896c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '224.3557',
      cy: '69.843',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm221.0645,57.46c-.46.2236-1.0605.334-1.8018.334-.9668,0-1.7275-.2832-2.2803-.8516-.5547-.5684-.8311-1.3262-.8311-2.2725,0-1.0078.3115-1.8252.9336-2.4521.623-.627,1.4307-.9404,2.4238-.9404.6152,0,1.1338.0781,1.5557.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0693.1865-1.4326.5586s-.5449.876-.5449,1.5117c0,.6094.1709,1.0947.5146,1.4561.3418.3623.8037.543,1.3838.543.5537,0,1.0605-.1348,1.5205-.4043v1.2959Z',
      },
      {
        className: 'cls-8',
        d: 'm222.0889,57.4775v-1.208c.4219.3076.9141.4619,1.4766.4619.3535,0,.6299-.0762.8281-.2285.1973-.1523.2969-.3652.2969-.6377,0-.2812-.123-.498-.3672-.6504-.2451-.1523-.5811-.2285-1.0088-.2285h-.5674v-1.0635h.5234c.8203,0,1.2305-.2725,1.2305-.8174,0-.5127-.3154-.7686-.9453-.7686-.4219,0-.832.1357-1.2305.4082v-1.1338c.4424-.2227.959-.334,1.5469-.334.6445,0,1.1465.1455,1.5059.4346.3584.291.5381.667.5381,1.1299,0,.8232-.417,1.3389-1.2529,1.5469v.0225c.4453.0557.7969.2168,1.0547.4854.2578.2676.3867.5967.3867.9863,0,.5889-.2148,1.0547-.6455,1.3975s-1.0254.5137-1.7842.5137c-.6504,0-1.1797-.1055-1.5859-.3164Z',
      },
      {
        className: 'cls-8',
        d: 'm227.3223,57.5479v-1.1426c.3311.2178.7295.3262,1.1953.3262.4863,0,.8623-.165,1.127-.4951.2656-.3291.3994-.7979.4023-1.4033l-.0264-.0098c-.2783.4141-.7021.6201-1.2705.6201-.5156,0-.9424-.1807-1.2803-.54-.3389-.3613-.5078-.8281-.5078-1.4023,0-.6709.2061-1.209.6201-1.6152.4121-.4053.9473-.6084,1.6035-.6084.6738,0,1.2109.2549,1.6104.7646.4004.5098.6006,1.2393.6006,2.1885,0,1.125-.2412,2-.7236,2.626-.4814.625-1.1553.9375-2.0186.9375-.5137,0-.957-.082-1.332-.2461Zm1.8242-5.2109c-.2412,0-.4385.0967-.5938.292-.1553.1943-.2324.4463-.2324.7529,0,.3203.0762.5713.2305.7539.1533.1836.3623.2754.626.2754.2402,0,.4365-.0879.5889-.2617.1523-.1748.2285-.3936.2285-.6572,0-.3311-.0801-.6064-.2393-.8262-.1602-.2197-.3623-.3291-.6084-.3291Z',
      },
    ],

    relatedApartments: {
      2: 'C027',
      3: 'C029',
      4: 'C034',
      6: 'C044',
      7: 'C049',
      8: 'C054-2',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'C040',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'C040',
    sceneName: 'scene_05krs_C040',
    sceneName_future: 'scene_05krs_C040_future',
    name: 'C040',
    label: 'C40',
    lookAt: '-209.68, 0, 120',
    face: 'south',
    area: {
      className: 'cls-30',
      points: '',
      x: '174.5834',
      y: '43.4353',
      width: '32.9583',
      height: '30.5006',
    },
    viewCone: {
      className: 'cls-2',
      pathData:
        'm194.1999,74.1422c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '191.5223',
      cy: '69.6956',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm188.7344,57.2412c-.46.2236-1.0605.334-1.8018.334-.9668,0-1.7275-.2832-2.2803-.8516-.5547-.5684-.8311-1.3262-.8311-2.2725,0-1.0078.3115-1.8252.9336-2.4521.623-.627,1.4307-.9404,2.4238-.9404.6152,0,1.1338.0781,1.5557.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0693.1865-1.4326.5586s-.5449.876-.5449,1.5117c0,.6094.1709,1.0947.5146,1.4561.3418.3623.8037.543,1.3838.543.5537,0,1.0605-.1348,1.5205-.4043v1.2959Z',
      },
      {
        className: 'cls-8',
        d: 'm193.8223,56.3447h-.7559v1.3398h-1.2656v-1.3398h-2.7461v-.8838l2.6445-4.0781h1.3672v3.9727h.7559v.9893Zm-2.0039-3.5732h-.0264c-.041.1055-.1201.2695-.2373.4922l-1.3496,2.0918h1.5957v-1.9814c0-.1758.0059-.377.0176-.6025Z',
      },
      {
        className: 'cls-8',
        d: 'm196.6172,57.7939c-1.5,0-2.25-1.0527-2.25-3.1592,0-1.0928.2031-1.9258.6084-2.498.4062-.5732.9941-.8594,1.7646-.8594,1.4648,0,2.1973,1.0713,2.1973,3.2119,0,1.0674-.2002,1.8848-.5996,2.4531-.4004.5684-.9736.8516-1.7207.8516Zm.0615-5.457c-.6006,0-.9004.7539-.9004,2.2627,0,1.4209.2939,2.1318.8828,2.1318.5742,0,.8613-.7324.8613-2.1973s-.2812-2.1973-.8438-2.1973Z',
      },
    ],

    relatedApartments: {
      2: 'C027',
      3: 'C030',
      4: 'C035',
      6: 'C045',
      7: 'C050',
      8: 'C054-2',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'C042',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'C042',
    sceneName: 'scene_05krs_C042',
    sceneName_future: 'scene_05krs_C042_future',
    name: 'C042',
    label: 'C42',
    lookAt: '-389.51, 0, 120',
    face: 'north',
    area: {
      className: 'cls-30',
      points:
        '229.5 14.4264 229.5 28.9291 222.5833 28.9291 222.5833 36.6111 194.25 36.6111 194.25 14.4295 229.5 14.4264',
    },
    viewCone: {
      className: 'cls-1',
      pathData:
        'm203.818,22.438c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '201.1404',
      cy: '17.9914',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm206.1289,31.002c-.46.2236-1.0605.334-1.8018.334-.9668,0-1.7275-.2832-2.2803-.8516-.5547-.5684-.8311-1.3262-.8311-2.2725,0-1.0078.3115-1.8252.9336-2.4521.623-.627,1.4307-.9404,2.4238-.9404.6152,0,1.1338.0781,1.5557.2334v1.3662c-.4219-.252-.9023-.3779-1.4414-.3779-.5918,0-1.0693.1865-1.4326.5586s-.5449.876-.5449,1.5117c0,.6094.1709,1.0947.5146,1.4561.3418.3623.8037.543,1.3838.543.5537,0,1.0605-.1348,1.5205-.4043v1.2959Z',
      },
      {
        className: 'cls-8',
        d: 'm211.4463,29.8867h-.7559v1.3398h-1.2656v-1.3398h-2.7461v-.8838l2.6445-4.0781h1.3672v3.9727h.7559v.9893Zm-2.0039-3.5732h-.0264c-.041.1055-.1201.2695-.2373.4922l-1.3496,2.0918h1.5957v-1.9814c0-.1758.0059-.377.0176-.6025Z',
      },
      {
        className: 'cls-8',
        d: 'm213.7539,30.0488v.0264h2.5566v1.1514h-4.1484v-1.0811l1.8066-1.7275c.3633-.3477.6191-.6406.7666-.876.1484-.2363.2217-.4844.2217-.7451,0-.5801-.3115-.8701-.9355-.8701-.542,0-1.0605.2158-1.5557.6455v-1.2207c.5479-.3545,1.166-.5322,1.8545-.5322.6445,0,1.1475.1621,1.5098.4854.3613.3242.543.7617.543,1.3125,0,.7354-.4414,1.4951-1.3232,2.2803l-1.2959,1.1514Z',
      },
    ],

    relatedApartments: {
      2: 'C027',
      3: 'C032',
      4: 'C037',
      6: 'C047',
      7: 'C052',
      8: 'C055',
      9: 'C058',
      10: 'C057-2',
    },
  },
  {
    id: 'D067',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'D067',
    sceneName: 'scene_05krs_D067',
    sceneName_future: 'scene_05krs_D067_future',
    name: 'D067',
    label: 'D67',
    lookAt: '-125.09, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-30',
      points:
        '240 65.4167 277.3632 65.2781 279.9633 93.8129 234.1944 98.7083 231.9167 74 240.7722 73.9349 240 65.4167',
    },
    viewCone: {
      className: 'cls-28',
      pathData:
        'm240.3152,90.3523c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '237.5015',
      cy: '86.0801',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm250.9072,83v-6.3018h2.2324c2.2383,0,3.3574,1.0244,3.3574,3.0713,0,.9824-.3057,1.7656-.916,2.3516-.6113.5859-1.4248.8789-2.4414.8789h-2.2324Zm1.4199-5.1465v3.9951h.7031c.6152,0,1.0977-.1846,1.4473-.5537.3506-.3691.5254-.8711.5254-1.5078,0-.5996-.1738-1.0723-.5205-1.417-.3477-.3438-.835-.5166-1.4619-.5166h-.6934Z',
      },
      {
        className: 'cls-8',
        d: 'm261.252,76.7637v1.1602c-.3193-.1807-.668-.2715-1.0459-.2715-.4658,0-.8418.1777-1.127.5332-.2861.3564-.4346.833-.4463,1.4307h.0264c.3018-.4453.7432-.668,1.3232-.668.5273,0,.9453.1787,1.2539.5361.3096.3574.4639.8301.4639,1.4199,0,.6328-.2051,1.1582-.6152,1.5771s-.9316.6279-1.5645.6279c-.709,0-1.2627-.2559-1.6611-.7686s-.5977-1.2314-.5977-2.1572c0-1.0898.2559-1.9609.7695-2.6133.5117-.6514,1.208-.9775,2.0869-.9775.4863,0,.8643.0576,1.1338.1709Zm-1.7402,3.2129c-.2549,0-.458.0898-.6084.2676-.1514.1797-.2266.4082-.2266.6855,0,.3086.0771.5713.2305.7891.1543.2188.3584.3281.6133.3281.249,0,.4482-.0977.5977-.293.1494-.1943.2236-.4482.2236-.7617,0-.6777-.2764-1.0156-.8301-1.0156Z',
      },
      {
        className: 'cls-8',
        d: 'm266.8066,77.3398l-2.2236,5.6602h-1.4678l2.2412-5.168h-2.9355v-1.1338h4.3857v.6416Z',
      },
    ],

    relatedApartments: {
      2: 'D059',
      3: 'D061',
      4: 'D064',
      6: 'D070',
      7: 'D073',
      8: 'D076',
      9: 'D076-2',
      10: 'C057-2',
    },
  },
  {
    id: 'D068',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'D068',
    sceneName: 'scene_05krs_D068',
    sceneName_future: 'scene_05krs_D068_future',
    name: 'D068',
    label: 'D68',
    lookAt: '-125.09, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-30',
      points:
        '239.25 155.5417 237.0528 131.3664 245.9156 130.6686 271 128.25 270.25 121.25 282.3577 120.0901 285.9897 159.9492 248.875 163.3125 239.25 155.5417',
    },
    viewCone: {
      className: 'cls-12',
      pathData:
        'm245.235,150.2511c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '242.5574',
      cy: '145.8045',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm258.71,147.4092v-6.3018h2.2324c2.2383,0,3.3574,1.0244,3.3574,3.0713,0,.9824-.3057,1.7656-.916,2.3516-.6113.5859-1.4248.8789-2.4414.8789h-2.2324Zm1.4199-5.1465v3.9951h.7031c.6152,0,1.0977-.1846,1.4473-.5537.3506-.3691.5254-.8711.5254-1.5078,0-.5996-.1738-1.0723-.5205-1.417-.3477-.3438-.835-.5166-1.4619-.5166h-.6934Z',
      },
      {
        className: 'cls-8',
        d: 'm269.0547,141.1729v1.1602c-.3193-.1807-.668-.2715-1.0459-.2715-.4658,0-.8418.1777-1.127.5332-.2861.3564-.4346.833-.4463,1.4307h.0264c.3018-.4453.7432-.668,1.3232-.668.5273,0,.9453.1787,1.2539.5361.3096.3574.4639.8301.4639,1.4199,0,.6328-.2051,1.1582-.6152,1.5771s-.9316.6279-1.5645.6279c-.709,0-1.2627-.2559-1.6611-.7686s-.5977-1.2314-.5977-2.1572c0-1.0898.2559-1.9609.7695-2.6133.5117-.6514,1.208-.9775,2.0869-.9775.4863,0,.8643.0576,1.1338.1709Zm-1.7402,3.2129c-.2549,0-.458.0898-.6084.2676-.1514.1797-.2266.4082-.2266.6855,0,.3086.0771.5713.2305.7891.1543.2188.3584.3281.6133.3281.249,0,.4482-.0977.5977-.293.1494-.1943.2236-.4482.2236-.7617,0-.6777-.2764-1.0156-.8301-1.0156Z',
      },
      {
        className: 'cls-8',
        d: 'm271.4326,144.1357v-.0225c-.7207-.2959-1.082-.7744-1.082-1.4365,0-.4863.1934-.8877.5801-1.2021.3867-.3154.8867-.4727,1.499-.4727.624,0,1.1221.1475,1.4941.4414.3721.2949.5576.6748.5576,1.1406,0,.6885-.3984,1.1953-1.1953,1.5205v.0176c.4277.126.7598.333.9961.6221.2354.2881.3535.6123.3535.9736,0,.5566-.2061.9961-.6172,1.3184-.4121.3223-.9863.4824-1.7246.4824-.6396,0-1.1543-.1572-1.5449-.4717-.3916-.3154-.5869-.7314-.5869-1.251,0-.752.4229-1.3057,1.2705-1.6602Zm.9268.5273c-.5889.2314-.8838.5859-.8838,1.0625,0,.2285.0908.418.2705.5674.1807.1494.3994.2236.6572.2236.2783,0,.502-.0723.6719-.2188s.2559-.3398.2559-.5801c0-.4805-.3242-.832-.9717-1.0547Zm.8174-1.9609c0-.2129-.0684-.3838-.2041-.5117-.1367-.127-.3174-.1914-.543-.1914-.2197,0-.4023.0674-.5469.2002-.1455.1338-.2178.3047-.2178.5127,0,.3926.252.6895.7559.8916.5039-.208.7559-.5078.7559-.9014Z',
      },
    ],

    relatedApartments: {
      2: 'D060',
      3: 'D062',
      4: 'D065',
      6: 'D071',
      7: 'D074',
      8: 'D077-1',
      9: 'D076-1',
      10: 'C057-1',
    },
  },
  {
    id: 'D069',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'D069',
    sceneName: 'scene_05krs_D069',
    sceneName_future: 'scene_05krs_D069_future',
    name: 'D069',
    label: 'D69',
    lookAt: '-125.09, 0, 120',
    face: 'south-west',
    area: {
      className: 'cls-30',
      points:
        '271 128.25 237.0528 131.3664 234.0051 97.8329 258.0814 95.7269 258.8958 106.6042 265.9444 106.125 266.5 113.0417 274.2778 112.5 275.071 120.7881 270.25 121.25 271 128.25',
    },
    viewCone: {
      className: 'cls-22',
      pathData:
        'm242.5047,117.7689c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '239.8271',
      cy: '113.3223',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm248.167,120v-6.3018h2.2324c2.2383,0,3.3574,1.0244,3.3574,3.0713,0,.9824-.3057,1.7656-.916,2.3516-.6113.5859-1.4248.8789-2.4414.8789h-2.2324Zm1.4199-5.1465v3.9951h.7031c.6152,0,1.0977-.1846,1.4473-.5537.3506-.3691.5254-.8711.5254-1.5078,0-.5996-.1738-1.0723-.5205-1.417-.3477-.3438-.835-.5166-1.4619-.5166h-.6934Z',
      },
      {
        className: 'cls-8',
        d: 'm258.5117,113.7637v1.1602c-.3193-.1807-.668-.2715-1.0459-.2715-.4658,0-.8418.1777-1.127.5332-.2861.3564-.4346.833-.4463,1.4307h.0264c.3018-.4453.7432-.668,1.3232-.668.5273,0,.9453.1787,1.2539.5361.3096.3574.4639.8301.4639,1.4199,0,.6328-.2051,1.1582-.6152,1.5771s-.9316.6279-1.5645.6279c-.709,0-1.2627-.2559-1.6611-.7686s-.5977-1.2314-.5977-2.1572c0-1.0898.2559-1.9609.7695-2.6133.5117-.6514,1.208-.9775,2.0869-.9775.4863,0,.8643.0576,1.1338.1709Zm-1.7402,3.2129c-.2549,0-.458.0898-.6084.2676-.1514.1797-.2266.4082-.2266.6855,0,.3086.0771.5713.2305.7891.1543.2188.3584.3281.6133.3281.249,0,.4482-.0977.5977-.293.1494-.1943.2236-.4482.2236-.7617,0-.6777-.2764-1.0156-.8301-1.0156Z',
      },
      {
        className: 'cls-8',
        d: 'm259.9619,119.8633v-1.1426c.3311.2178.7295.3262,1.1953.3262.4863,0,.8623-.165,1.127-.4951.2656-.3291.3994-.7979.4023-1.4033l-.0264-.0098c-.2783.4141-.7021.6201-1.2705.6201-.5156,0-.9424-.1807-1.2803-.54-.3389-.3613-.5078-.8281-.5078-1.4023,0-.6709.2061-1.209.6201-1.6152.4121-.4053.9473-.6084,1.6035-.6084.6738,0,1.2109.2549,1.6104.7646.4004.5098.6006,1.2393.6006,2.1885,0,1.125-.2412,2-.7236,2.626-.4814.625-1.1553.9375-2.0186.9375-.5137,0-.957-.082-1.332-.2461Zm1.8242-5.2109c-.2412,0-.4385.0967-.5938.292-.1553.1943-.2324.4463-.2324.7529,0,.3203.0762.5713.2305.7539.1533.1836.3623.2754.626.2754.2402,0,.4365-.0879.5889-.2617.1523-.1748.2285-.3936.2285-.6572,0-.3311-.0801-.6064-.2393-.8262-.1602-.2197-.3623-.3291-.6084-.3291Z',
      },
    ],

    relatedApartments: {
      2: 'D059',
      3: 'D063',
      4: 'D066',
      6: 'D072',
      7: 'D075',
      8: 'D077-2',
      9: 'D076-2',
      10: 'C057-2',
    },
  },
  {
    id: 'E092',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'E092',
    sceneName: 'scene_05krs_E092',
    sceneName_future: 'scene_05krs_E092_future',
    name: 'E092',
    label: 'E92',
    lookAt: '-35.04, 0, 120',
    face: 'north-west',
    area: {
      className: 'cls-30',
      points:
        '222.2083 188 193.4783 190.716 192.5888 159.7677 219.4773 157.3325 222.2083 188',
    },
    viewCone: {
      className: 'cls-26',
      pathData:
        'm209.4291,167.1894c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '206.7515',
      cy: '162.7428',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm204.3262,181h-3.7793v-6.3018h3.6348v1.1553h-2.2148v1.4023h2.0605v1.1514h-2.0605v1.4414h2.3594v1.1514Z',
      },
      {
        className: 'cls-8',
        d: 'm205.3193,180.8633v-1.1426c.3311.2178.7295.3262,1.1953.3262.4863,0,.8623-.165,1.127-.4951.2656-.3291.3994-.7979.4023-1.4033l-.0264-.0098c-.2783.4141-.7021.6201-1.2705.6201-.5156,0-.9424-.1807-1.2803-.54-.3389-.3613-.5078-.8281-.5078-1.4023,0-.6709.2061-1.209.6201-1.6152.4121-.4053.9473-.6084,1.6035-.6084.6738,0,1.2109.2549,1.6104.7646.4004.5098.6006,1.2393.6006,2.1885,0,1.125-.2412,2-.7236,2.626-.4814.625-1.1553.9375-2.0186.9375-.5137,0-.957-.082-1.332-.2461Zm1.8242-5.2109c-.2412,0-.4385.0967-.5938.292-.1553.1943-.2324.4463-.2324.7529,0,.3203.0762.5713.2305.7539.1533.1836.3623.2754.626.2754.2402,0,.4365-.0879.5889-.2617.1523-.1748.2285-.3936.2285-.6572,0-.3311-.0801-.6064-.2393-.8262-.1602-.2197-.3623-.3291-.6084-.3291Z',
      },
      {
        className: 'cls-8',
        d: 'm211.8633,179.8223v.0264h2.5566v1.1514h-4.1484v-1.0811l1.8066-1.7275c.3633-.3477.6191-.6406.7666-.876.1484-.2363.2217-.4844.2217-.7451,0-.5801-.3115-.8701-.9355-.8701-.542,0-1.0605.2158-1.5557.6455v-1.2207c.5479-.3545,1.166-.5322,1.8545-.5322.6445,0,1.1475.1621,1.5098.4854.3613.3242.543.7617.543,1.3125,0,.7354-.4414,1.4951-1.3232,2.2803l-1.2959,1.1514Z',
      },
    ],

    relatedApartments: {
      2: 'E078',
      3: 'E080',
      4: 'E086',
      6: 'E099',
      7: 'E104',
      8: 'D077-1',
      9: 'D076-1',
      10: 'C057-1',
    },
  },
  {
    id: 'E093',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'E093',
    sceneName: 'scene_05krs_E093',
    sceneName_future: 'scene_05krs_E093_future',
    name: 'E093',
    label: 'E93',
    lookAt: '-35.04, 0, 120',
    face: 'north-west',
    area: {
      className: 'cls-30',
      points:
        '250.8858 185.5429 222.2083 188 219.4773 157.3325 239.25 155.5417 248.875 163.3125 250.8858 185.5429',
    },
    viewCone: {
      className: 'cls-4',
      pathData:
        'm235.1791,165.0401c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '232.5015',
      cy: '160.5935',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm232.8242,178.6689h-3.7793v-6.3018h3.6348v1.1553h-2.2148v1.4023h2.0605v1.1514h-2.0605v1.4414h2.3594v1.1514Z',
      },
      {
        className: 'cls-8',
        d: 'm233.8174,178.5322v-1.1426c.3311.2178.7295.3262,1.1953.3262.4863,0,.8623-.165,1.127-.4951.2656-.3291.3994-.7979.4023-1.4033l-.0264-.0098c-.2783.4141-.7021.6201-1.2705.6201-.5156,0-.9424-.1807-1.2803-.54-.3389-.3613-.5078-.8281-.5078-1.4023,0-.6709.2061-1.209.6201-1.6152.4121-.4053.9473-.6084,1.6035-.6084.6738,0,1.2109.2549,1.6104.7646.4004.5098.6006,1.2393.6006,2.1885,0,1.125-.2412,2-.7236,2.626-.4814.625-1.1553.9375-2.0186.9375-.5137,0-.957-.082-1.332-.2461Zm1.8242-5.2109c-.2412,0-.4385.0967-.5938.292-.1553.1943-.2324.4463-.2324.7529,0,.3203.0762.5713.2305.7539.1533.1836.3623.2754.626.2754.2402,0,.4365-.0879.5889-.2617.1523-.1748.2285-.3936.2285-.6572,0-.3311-.0801-.6064-.2393-.8262-.1602-.2197-.3623-.3291-.6084-.3291Z',
      },
      {
        className: 'cls-8',
        d: 'm238.9375,178.4619v-1.208c.4219.3076.9141.4619,1.4766.4619.3535,0,.6299-.0762.8281-.2285.1973-.1523.2969-.3652.2969-.6377,0-.2812-.123-.498-.3672-.6504-.2451-.1523-.5811-.2285-1.0088-.2285h-.5674v-1.0635h.5234c.8203,0,1.2305-.2725,1.2305-.8174,0-.5127-.3154-.7686-.9453-.7686-.4219,0-.832.1357-1.2305.4082v-1.1338c.4424-.2227.959-.334,1.5469-.334.6445,0,1.1465.1455,1.5059.4346.3584.291.5381.667.5381,1.1299,0,.8232-.417,1.3389-1.2529,1.5469v.0225c.4453.0557.7969.2168,1.0547.4854.2578.2676.3867.5967.3867.9863,0,.5889-.2148,1.0547-.6455,1.3975s-1.0254.5137-1.7842.5137c-.6504,0-1.1797-.1055-1.5859-.3164Z',
      },
    ],

    relatedApartments: {
      2: 'E078',
      3: 'E081',
      4: 'E087',
      6: 'E100',
      7: 'E104',
      8: 'D077-1',
      9: 'D076-1',
      10: 'C057-1',
    },
  },
  {
    id: 'E094',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'E094',
    sceneName: 'scene_05krs_E094',
    sceneName_future: 'scene_05krs_E094_future',
    name: 'E094',
    label: 'E94',
    lookAt: '55.21, 0, 120',
    face: 'east',
    area: {
      className: 'cls-30',
      points:
        '285.9897 159.9492 288.6142 188.7522 247.3889 192.5 246.8333 185.8889 250.8858 185.5429 248.875 163.3125 285.9897 159.9492',
    },
    viewCone: {
      className: 'cls-5',
      pathData:
        'm284.6201,178.6102c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '281.9547',
      cy: '174.2421',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm261.5957,178.6689h-3.7793v-6.3018h3.6348v1.1553h-2.2148v1.4023h2.0605v1.1514h-2.0605v1.4414h2.3594v1.1514Z',
      },
      {
        className: 'cls-8',
        d: 'm262.5889,178.5322v-1.1426c.3311.2178.7295.3262,1.1953.3262.4863,0,.8623-.165,1.127-.4951.2656-.3291.3994-.7979.4023-1.4033l-.0264-.0098c-.2783.4141-.7021.6201-1.2705.6201-.5156,0-.9424-.1807-1.2803-.54-.3389-.3613-.5078-.8281-.5078-1.4023,0-.6709.2061-1.209.6201-1.6152.4121-.4053.9473-.6084,1.6035-.6084.6738,0,1.2109.2549,1.6104.7646.4004.5098.6006,1.2393.6006,2.1885,0,1.125-.2412,2-.7236,2.626-.4814.625-1.1553.9375-2.0186.9375-.5137,0-.957-.082-1.332-.2461Zm1.8242-5.2109c-.2412,0-.4385.0967-.5938.292-.1553.1943-.2324.4463-.2324.7529,0,.3203.0762.5713.2305.7539.1533.1836.3623.2754.626.2754.2402,0,.4365-.0879.5889-.2617.1523-.1748.2285-.3936.2285-.6572,0-.3311-.0801-.6064-.2393-.8262-.1602-.2197-.3623-.3291-.6084-.3291Z',
      },
      {
        className: 'cls-8',
        d: 'm272.002,177.3291h-.7559v1.3398h-1.2656v-1.3398h-2.7461v-.8838l2.6445-4.0781h1.3672v3.9727h.7559v.9893Zm-2.0039-3.5732h-.0264c-.041.1055-.1201.2695-.2373.4922l-1.3496,2.0918h1.5957v-1.9814c0-.1758.0059-.377.0176-.6025Z',
      },
    ],

    relatedApartments: {
      2: 'E078',
      3: 'E082',
      4: 'E088',
      6: 'E101',
      7: 'E104',
      8: 'D077-1',
      9: 'D076-1',
      10: 'C057-1',
    },
  },
  {
    id: 'E095',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'E095',
    sceneName: 'scene_05krs_E095',
    sceneName_future: 'scene_05krs_E095_future',
    name: 'E095',
    label: 'E95',
    lookAt: '55.21, 0, 120',
    face: 'east',
    area: {
      className: 'cls-30',
      points:
        '290.625 210.8194 232.0341 216.1229 229.9583 194.1667 247.3889 192.5 288.6142 188.7522 290.625 210.8194',
    },
    viewCone: {
      className: 'cls-20',
      pathData:
        'm286.6323,203.4106c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '283.9547',
      cy: '198.9641',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm252.8691,206.2568h-3.7793v-6.3018h3.6348v1.1553h-2.2148v1.4023h2.0605v1.1514h-2.0605v1.4414h2.3594v1.1514Z',
      },
      {
        className: 'cls-8',
        d: 'm253.8623,206.1201v-1.1426c.3311.2178.7295.3262,1.1953.3262.4863,0,.8623-.165,1.127-.4951.2656-.3291.3994-.7979.4023-1.4033l-.0264-.0098c-.2783.4141-.7021.6201-1.2705.6201-.5156,0-.9424-.1807-1.2803-.54-.3389-.3613-.5078-.8281-.5078-1.4023,0-.6709.2061-1.209.6201-1.6152.4121-.4053.9473-.6084,1.6035-.6084.6738,0,1.2109.2549,1.6104.7646.4004.5098.6006,1.2393.6006,2.1885,0,1.125-.2412,2-.7236,2.626-.4814.625-1.1553.9375-2.0186.9375-.5137,0-.957-.082-1.332-.2461Zm1.8242-5.2109c-.2412,0-.4385.0967-.5938.292-.1553.1943-.2324.4463-.2324.7529,0,.3203.0762.5713.2305.7539.1533.1836.3623.2754.626.2754.2402,0,.4365-.0879.5889-.2617.1523-.1748.2285-.3936.2285-.6572,0-.3311-.0801-.6064-.2393-.8262-.1602-.2197-.3623-.3291-.6084-.3291Z',
      },
      {
        className: 'cls-8',
        d: 'm259.0566,206.0947v-1.1875c.4307.2637.8887.3965,1.375.3965.3662,0,.6533-.0879.8594-.2617.207-.1748.3105-.4111.3105-.71,0-.624-.4414-.9365-1.3232-.9365-.2871,0-.6348.0273-1.042.0801v-3.5205h3.4902v1.1338h-2.3027v1.2617c.1836-.0176.3584-.0273.5225-.0273.6475,0,1.1543.1709,1.5205.5098.3662.3408.5488.7979.5488,1.3711,0,.6367-.2178,1.1553-.6543,1.5586-.4365.4023-1.0283.6035-1.7754.6035-.6064,0-1.1162-.0908-1.5293-.2715Z',
      },
    ],

    relatedApartments: {
      2: 'E079',
      3: 'E083',
      4: 'E089',
      6: 'E102',
      7: 'E104',
      8: 'D077-1',
      9: 'D076-1',
      10: 'C057-1',
    },
  },
  {
    id: 'F119',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'F119',
    sceneName: 'scene_05krs_F119',
    sceneName_future: 'scene_05krs_F119_future',
    name: 'F119',
    label: 'F119',
    lookAt: '-27-75, 0, 120',
    face: 'north-east',
    area: {
      className: 'cls-30',
      points:
        '168.454 218.5825 148.9616 217.8432 149.1667 210.8889 135.7778 210.2778 136.1111 195.8333 142.8333 196.0625 143.0625 188.8542 136.2917 188.625 136.9178 166.4703 123.825 165.9669 124.2161 157.308 170.789 159.1898 168.454 218.5825',
    },
    viewCone: {
      className: 'cls-19',
      pathData:
        'm155.4708,167.1894c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '152.7932',
      cy: '162.7428',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm151.0713,189.0205h-2.2227v1.5469h2.043v1.1523h-2.043v2.4473h-1.4199v-6.3018h3.6426v1.1553Z',
      },
      {
        className: 'cls-8',
        d: 'm156.1201,194.167h-3.9854v-1.0986h1.3057v-3.9248l-1.3408.291v-1.125l2.7246-.5498v5.3086h1.2959v1.0986Z',
      },
      {
        className: 'cls-8',
        d: 'm158.6357,192.9893v.0264h2.5566v1.1514h-4.1484v-1.0811l1.8066-1.7275c.3633-.3477.6191-.6406.7666-.876.1484-.2363.2217-.4844.2217-.7451,0-.5801-.3115-.8701-.9355-.8701-.542,0-1.0605.2158-1.5557.6455v-1.2207c.5479-.3545,1.166-.5322,1.8545-.5322.6445,0,1.1475.1621,1.5098.4854.3613.3242.543.7617.543,1.3125,0,.7354-.4414,1.4951-1.3232,2.2803l-1.2959,1.1514Z',
      },
      {
        className: 'cls-8',
        d: 'm164.2988,194.2764c-1.5,0-2.25-1.0527-2.25-3.1592,0-1.0928.2031-1.9258.6084-2.498.4062-.5732.9941-.8594,1.7646-.8594,1.4648,0,2.1973,1.0713,2.1973,3.2119,0,1.0674-.2002,1.8848-.5996,2.4531-.4004.5684-.9736.8516-1.7207.8516Zm.0615-5.457c-.6006,0-.9004.7539-.9004,2.2627,0,1.4209.2939,2.1318.8828,2.1318.5742,0,.8613-.7324.8613-2.1973s-.2812-2.1973-.8438-2.1973Z',
      },
    ],

    relatedApartments: {
      2: 'G122',
      3: 'F111',
      4: 'F116',
      6: 'E098-2',
      7: 'E103',
      8: 'D077-1',
      9: 'D076-1',
      10: 'C057-1',
    },
  },
  {
    id: 'E091',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'E091',
    sceneName: 'scene_05krs_E091',
    sceneName_future: 'scene_05krs_E091_future',
    name: 'E091',
    label: 'E091',
    lookAt: '-27-75, 0, 120',
    face: 'north-east',
    area: {
      className: 'cls-30',
      points:
        '194.1111 219.5556 168.454 218.5825 170.789 159.1898 192.5888 159.7677 194.1111 219.5556',
    },
    viewCone: {
      className: 'cls-11',
      pathData:
        'm184.4184,168.3172c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '181.7407',
      cy: '163.8706',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm178.7949,197.3594h-3.7793v-6.3018h3.6348v1.1553h-2.2148v1.4023h2.0605v1.1514h-2.0605v1.4414h2.3594v1.1514Z',
      },
      {
        className: 'cls-8',
        d: 'm179.7881,197.2227v-1.1426c.3311.2178.7295.3262,1.1953.3262.4863,0,.8623-.165,1.127-.4951.2656-.3291.3994-.7979.4023-1.4033l-.0264-.0098c-.2783.4141-.7021.6201-1.2705.6201-.5156,0-.9424-.1807-1.2803-.54-.3389-.3613-.5078-.8281-.5078-1.4023,0-.6709.2061-1.209.6201-1.6152.4121-.4053.9473-.6084,1.6035-.6084.6738,0,1.2109.2549,1.6104.7646.4004.5098.6006,1.2393.6006,2.1885,0,1.125-.2412,2-.7236,2.626-.4814.625-1.1553.9375-2.0186.9375-.5137,0-.957-.082-1.332-.2461Zm1.8242-5.2109c-.2412,0-.4385.0967-.5938.292-.1553.1943-.2324.4463-.2324.7529,0,.3203.0762.5713.2305.7539.1533.1836.3623.2754.626.2754.2402,0,.4365-.0879.5889-.2617.1523-.1748.2285-.3936.2285-.6572,0-.3311-.0801-.6064-.2393-.8262-.1602-.2197-.3623-.3291-.6084-.3291Z',
      },
      {
        className: 'cls-8',
        d: 'm188.9941,197.3594h-3.9854v-1.0986h1.3057v-3.9248l-1.3408.291v-1.125l2.7246-.5498v5.3086h1.2959v1.0986Z',
      },
    ],

    relatedApartments: {
      2: 'G122',
      3: 'F111',
      4: 'E085',
      6: 'E098-2',
      7: 'E103',
      8: 'D077-1',
      9: 'D076-1',
      10: 'C057-1',
    },
  },
  {
    id: 'F120',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'F120',
    sceneName: 'scene_05krs_F120',
    sceneName_future: 'scene_05krs_F120_future',
    name: 'F120',
    label: 'F120',
    lookAt: '-209.68, 0, 120',
    face: 'south',
    area: {
      className: 'cls-30',
      points:
        '148.9616 217.8432 135.4792 217.3318 135.7778 210.2778 149.1667 210.8889 148.9616 217.8432',
    },
    viewCone: {
      className: 'cls-23',
      pathData:
        'm145.3458,218.8223c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '142.6682',
      cy: '214.3758',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: '',
      },
      {
        className: 'cls-8',
        d: '',
      },
      {
        className: 'cls-8',
        d: '',
      },
      {
        className: 'cls-8',
        d: '',
      },
    ],

    relatedApartments: {
      2: 'G122',
      3: 'F112',
      4: 'F117',
      6: 'E098-2',
      7: 'E103',
      8: 'D077-2',
      9: 'D076-2',
      10: 'C057-2',
    },
  },
  {
    id: 'F118',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'F118',
    sceneName: 'scene_05krs_F118',
    sceneName_future: 'scene_05krs_F118_future',
    name: 'F118',
    label: 'F118',
    lookAt: '-117.65, 0, 120',
    face: 'north-west',
    area: {
      className: 'cls-30',
      points:
        '124.1644 216.9027 66.3333 214.5556 68.2094 163.8274 136.9178 166.4703 136.2917 188.625 118.0833 187.7292 117.5 202.4444 124.7778 202.6667 124.1644 216.9027',
    },
    viewCone: {
      className: 'cls-10',
      pathData:
        'm90.7605,192.2568c-.8603.3577-1.798.5607-2.7936.5607-1.0053,0-1.9623-.203-2.8226-.58l-18.8109,43.4121h42.3294l-17.9023-43.3927Z',
      cx: '88.0829',
      cy: '187.8102',
      circleClassName: 'cls-16',
    },
    namePaths: [
      {
        className: 'cls-8',
        d: 'm113.4131,175.8535h-2.2227v1.5469h2.043v1.1523h-2.043v2.4473h-1.4199v-6.3018h3.6426v1.1553Z',
      },
      {
        className: 'cls-8',
        d: 'm118.4619,181h-3.9854v-1.0986h1.3057v-3.9248l-1.3408.291v-1.125l2.7246-.5498v5.3086h1.2959v1.0986Z',
      },
      {
        className: 'cls-8',
        d: 'm123.6396,181h-3.9854v-1.0986h1.3057v-3.9248l-1.3408.291v-1.125l2.7246-.5498v5.3086h1.2959v1.0986Z',
      },
      {
        className: 'cls-8',
        d: 'm125.7139,177.7266v-.0225c-.7207-.2959-1.082-.7744-1.082-1.4365,0-.4863.1934-.8877.5801-1.2021.3867-.3154.8867-.4727,1.499-.4727.624,0,1.1221.1475,1.4941.4414.3721.2949.5576.6748.5576,1.1406,0,.6885-.3984,1.1953-1.1953,1.5205v.0176c.4277.126.7598.333.9961.6221.2354.2881.3535.6123.3535.9736,0,.5566-.2061.9961-.6172,1.3184-.4121.3223-.9863.4824-1.7246.4824-.6396,0-1.1543-.1572-1.5449-.4717-.3916-.3154-.5869-.7314-.5869-1.251,0-.752.4229-1.3057,1.2705-1.6602Zm.9268.5273c-.5889.2314-.8838.5859-.8838,1.0625,0,.2285.0908.418.2705.5674.1807.1494.3994.2236.6572.2236.2783,0,.502-.0723.6719-.2188s.2559-.3398.2559-.5801c0-.4805-.3242-.832-.9717-1.0547Zm.8174-1.9609c0-.2129-.0684-.3838-.2041-.5117-.1367-.127-.3174-.1914-.543-.1914-.2197,0-.4023.0674-.5469.2002-.1455.1338-.2178.3047-.2178.5127,0,.3926.252.6895.7559.8916.5039-.208.7559-.5078.7559-.9014Z',
      },
    ],

    relatedApartments: {
      2: 'G122',
      3: 'F108',
      4: 'F114',
      6: 'E098-1',
      7: 'E103',
      8: 'D077-2',
      9: 'D076-2',
      10: 'C057-2',
    },
  },
]
